import * as React from "react";
import { SVGProps } from "react";
export const MapFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11.896 17.292L7.542 15.75L3.646 17.271C3.368 17.3823 3.10767 17.351 2.865 17.177C2.62167 17.0037 2.5 16.764 2.5 16.458V4.812C2.5 4.618 2.55567 4.45167 2.667 4.313C2.77767 4.17367 2.92333 4.06934 3.104 4L6.979 2.688C7.15967 2.632 7.34733 2.604 7.542 2.604C7.736 2.604 7.92333 2.63867 8.104 2.708L12.479 4.229L16.396 2.708C16.6733 2.61067 16.9267 2.649 17.156 2.823C17.3853 2.99634 17.5 3.229 17.5 3.521V15.188C17.5 15.368 17.448 15.5277 17.344 15.667C17.24 15.8057 17.1047 15.9097 16.938 15.979L13.062 17.312C12.868 17.382 12.6737 17.4133 12.479 17.406C12.285 17.3993 12.0907 17.3613 11.896 17.292ZM11.604 15.354V5.75L8.417 4.646V14.25L11.604 15.354Z"
            fill="currentColor"
        />
    </svg>
);
MapFillIcon.displayName = "MapFillIcon";
